module.exports = __webpack_public_path__ + "static/media/backgroundImage.46eefe96.jpg";